export const FETCH_PAYMENTISSUE_REQUEST = "FETCH_PAYMENTISSUE_REQUEST";
export const FETCH_PAYMENTISSUE_SUCCESS = "FETCH_PAYMENTISSUE_SUCCESS";
export const FETCH_PAYMENTISSUE_FAILURE = "FETCH_PAYMENTISSUE_FAILURE";

export const SEARCH_PAYMENTISSUE_REQUEST = 'SEARCH_PAYMENTISSUE_REQUEST';
export const SEARCH_PAYMENTISSUE_SUCCESS = 'SEARCH_PAYMENTISSUE_SUCCESS';
export const SEARCH_PAYMENTISSUE_FAILURE = 'SEARCH_PAYMENTISSUE_FAILURE';

export const fetchIssuesRequest = (page, limit) => ({
  type: FETCH_PAYMENTISSUE_REQUEST,
  payload: { page, limit },
});

export const fetchIssuesSuccess = (paymentIssues) => ({
  type: FETCH_PAYMENTISSUE_SUCCESS,
  payload: paymentIssues,
});

export const fetchIssuesFailure = (error) => ({
  type: FETCH_PAYMENTISSUE_FAILURE,
  payload: error,
});

export const searchPaymentIssueRequest = (searchTerm) => ({
  type: SEARCH_PAYMENTISSUE_REQUEST,
  payload: { searchTerm },
});

export const searchPaymentIssueSuccess = (paymentIssues) => ({
  type: SEARCH_PAYMENTISSUE_SUCCESS,
  payload: paymentIssues,
});

export const searchPaymentIssueFailure = (error) => ({
  type: SEARCH_PAYMENTISSUE_FAILURE,
  payload: error,
});